import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { configure, searchBox, pagination, currentRefinements } from 'instantsearch.js/es/widgets'
import { connectHits, connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { history } from 'instantsearch.js/es/lib/routers'

import pageTemplate from 'templates/playground/user_page.mustache';

import _ from 'lodash'

export default class Search {
  constructor() {
    this.$searchInfo = $('#playground-search-info');
    this.app_id = this.$searchInfo.data('app-id');
    this.api_key = this.$searchInfo.data('app-key');
    this.appIndex = this.$searchInfo.data('app-index');
    this.app_uri = this.$searchInfo.data('app-uri');

    this.originalLocation = location.href;

    this.client = this._initClient();
    this.search = this._initSearch();

    this._addWidgets();
    this.search.start();
  }

  _initSearch() {
    const originalLocation = this.originalLocation;
    return instantsearch({
      searchClient: this.client,
      indexName: this.appIndex,
    });
  }

  _addWidgets() {
    // use results template
    const guideHits = connectHits(
      function renderHits({ hits, widgetParams }, isFirstRendering) {
        const container = widgetParams.container;

        if (hits.length) {
          $(container).html(hits.map(hit => pageTemplate.render(hit)));
        } else {
          $(container).html(widgetParams.templates.empty);
        }

      }
    );

    const renderListItem = item => {
      if (item.attribute === "query") {
        var refinementText = item.refinements
          .map(refinement => `"${refinement.value }"`).join('')

        return `
          Results for ${refinementText} <a href="/">view all notes</a>

        `
      }
    };

    const customRefinementsHeader = connectCurrentRefinements(
      function renderCurrentRefinements({ items, widgetParams }, isFirstRendering) {
        const container = widgetParams.container;

        // debugger
        // if (hits.length) {
        $(container).html(items.map(renderListItem).join(''))
        // } else {
          // $(container).html("");
        // }

      }
    );

    this.search.addWidgets([
      configure(
      {
        hitsPerPage: 21,
        distinct: true
      }),

      searchBox({
        container: '#search',
        showReset: false,
        showSubmit: false
      }),

      customRefinementsHeader({
        container: '#search-refinements',
        includedAttributes: ['query'],
        cssClasses: {
          label: 'refinement-label',
          delete: 'delete-refinement'
        },
      }),

      guideHits({
        container: '#search-results',
        templates: {
          empty: '<div class="no-results">No results for query</div>',
        },
      }),

      pagination({
        container: '#search-pagination',
        cssClasses: {
          item: 'item',
          link: 'link',
          selectedItem: 'selected',
          disabledItem: 'disabled'
        }
      })
    ]);
  }

  _initClient() {
    const algoliaClient = algoliasearch(this.app_id, this.api_key);
    const originalLocation = this.originalLocation;

    return {
      search(requests) {
        // don't render search until query/refienment entered
        if (requests.every( ({ params }) => !params.query && !params.facetFilters) ) {
          document.querySelector('#main-content').classList.remove('search-active');
          // stub initial search query
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
            })),
          });
        } else {
          document.querySelector('#main-content').classList.add('search-active');
        }

        return algoliaClient.search(requests);
      },
    };
  }
}
